<div class="flex h-screen text-base-content scroll-smooth font-poppins">
  <aside class="w-64 p-6 overflow-y-auto h-full">
    <nav class="space-y-2 scroll-smooth">
      <div class="mb-8">
        <h1 class="text-2xl font-bold mb-4 text-[#1594fd]">Overview</h1>
        <a href="/docs#quickstart"
          class="w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-200 hover:translate-x-2 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary group">
          <span class="text-black group-hover:text-[#1594fd] font-medium">Quickstart</span>
        </a>
        <a href="/docs#studies"
          class="w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-200 hover:translate-x-2 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary group">
          <span class="text-black group-hover:text-[#1594fd] font-medium">Studies</span>
        </a>
        <a href="/docs#workspace"
          class="w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-200 hover:translate-x-2 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary group">
          <span class="text-black group-hover:text-[#1594fd] font-medium">Workspace</span>
        </a>
        <a href="/docs#workflow"
          class="w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-200 hover:translate-x-2 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary group">
          <span class="text-black group-hover:text-[#1594fd] font-medium">Workflows</span>
        </a>
        <a href="/docs#faq"
          class="w-full text-left flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-200 hover:translate-x-2 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary group">
          <span class="text-black group-hover:text-[#1594fd] font-medium">FAQ</span>
        </a>
        <!-- <a href="#" class="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-base-200 group">
          <span class="text-base-content/60 group-hover:text-base-content/80 font-medium">Enterprise</span>
        </a> -->
      </div>
    </nav>
  </aside>

  <main class="flex-1 overflow-y-auto scroll-smooth h-full">
    <div class="container flex flex-col max-w-5xl m-auto space-y-8 pb-25">
      <!-- Quickstart Section -->
      <section id="quickstart" class="pl-8 relative">
        <div class="flex gap-8">
          <!-- Main Content -->
          <div class="flex-1">
            <h1 class="text-5xl font-bold mb-8 text-black tracking-tight">Quickstart</h1>
            <div class="mb-8">
              <p class="text-lg text-black leading-relaxed font-light">
                Get started with our platform in just a few simple steps. This quickstart guide will walk you through
                the essential features and functionalities to help you make the most out of your experience.
              </p>
            </div>

            <div class="space-y-8">
              <div class="group">
                <div class="flex items-start gap-4 mb-4">
                  <div
                    class="flex-shrink-0 w-8 h-8 bg-success text-success-content rounded-full flex items-center justify-center font-bold text-sm">
                    1</div>
                  <div class="flex-1">
                    <h3 class="text-2xl font-semibold mb-3 text-black">Click on Google Sign In button</h3>
                    <p class="text-black leading-relaxed font-light">This will allow you to sign in using your
                      Google account.</p>
                  </div>
                </div>
                <img src="assets/quickstart/signbutton.png" alt="Google Sign In"
                  class="ml-12 rounded-lg shadow-lg border border-base-300">
              </div>

              <div class="group">
                <div class="flex items-start gap-4 mb-4">
                  <div
                    class="flex-shrink-0 w-8 h-8 bg-success text-success-content rounded-full flex items-center justify-center font-bold text-sm">
                    2</div>
                  <div class="flex-1">
                    <h3 class="text-2xl font-semibold mb-3 text-black">Create a study</h3>
                    <p class="text-black leading-relaxed font-light">Click on the "+ Study" button to create a
                      new study. <a href="/docs#studies"
                        class="text-success underline hover:text-success-focus transition-colors font-medium">Learn more
                        here</a></p>
                  </div>
                </div>
                <img src="assets/quickstart/create-study-button.png" alt="Create Study"
                  class="ml-12 rounded-lg shadow-lg border border-base-300">
              </div>

              <div class="group">
                <div class="flex items-start gap-4 mb-4">
                  <div
                    class="flex-shrink-0 w-8 h-8 bg-success text-success-content rounded-full flex items-center justify-center font-bold text-sm">
                    3</div>
                  <div class="flex-1">
                    <h3 class="text-2xl font-semibold mb-3 text-black">Ask questions to explore your study</h3>
                    <p class="text-black leading-relaxed font-light">
                      Type your questions or use the messages below to start exploring your workspace.
                    </p>
                  </div>
                </div>
                <img src="assets/quickstart/text-area.png" alt="Ask Questions"
                  class="ml-12 rounded-lg shadow-lg border border-base-300">
              </div>
            </div>

          </div>
        </div>
      </section>


      <!-- Studies Section -->
      <section id="studies" class="scroll-mt-16 pl-8">
        <h1 class="text-5xl font-bold mb-8 text-black tracking-tight">Studies</h1>
        <div>
          <p class="mb-8 text-lg text-black leading-relaxed font-light">
            Studies are project containers in your workspace that organize all your research materials. Each study
            contains
            files, folders, and collaborative messages, providing a centralized space for your team to work together on
            research projects.
          </p>
          <div class="space-y-8">
            <div>
              <h3 class="text-3xl font-semibold mb-6 text-black">Cloud Storage</h3>
              <div class="space-y-8">
                <div class="group">
                  <div class="flex items-start gap-4 mb-4">
                    <div
                      class="flex-shrink-0 w-8 h-8 bg-secondary text-secondary-content rounded-full flex items-center justify-center font-bold text-sm">
                      1</div>
                    <div class="flex-1">
                      <h4 class="text-xl font-semibold mb-3 text-black">Creating a Study</h4>
                      <p class="text-black leading-relaxed font-light">To create a new study, click on the "+
                        Study" button on the home page.</p>
                    </div>
                  </div>
                  <img src="assets/quickstart/create-study.png" alt="Create Study"
                    class="ml-12 rounded-lg shadow-lg border border-base-300">
                </div>

                <div class="group">
                  <div class="flex items-start gap-4 mb-4">
                    <div
                      class="flex-shrink-0 w-8 h-8 bg-secondary text-secondary-content rounded-full flex items-center justify-center font-bold text-sm">
                      2</div>
                    <div class="flex-1">
                      <h4 class="text-xl font-semibold mb-3 text-black">Click on cloud storage</h4>
                      <p class="text-black leading-relaxed font-light">to create study on cloud</p>
                    </div>
                  </div>
                  <img src="assets/quickstart/Cloud-study.png" alt="Cloud Study"
                    class="ml-12 rounded-lg shadow-lg border border-base-300">
                </div>

                <div class="group">
                  <div class="flex items-start gap-4 mb-4">
                    <div
                      class="flex-shrink-0 w-8 h-8 bg-secondary text-secondary-content rounded-full flex items-center justify-center font-bold text-sm">
                      3</div>
                    <div class="flex-1">
                      <h4 class="text-xl font-semibold mb-3 text-black">Give cloud study name and click on create study
                      </h4>
                      <p class="text-black leading-relaxed font-light">Enter a name for your cloud study and
                        click the "Create Study" button which
                        will create a container for your workspace</p>
                    </div>
                  </div>
                  <img src="assets/quickstart/study-name.png" alt="Cloud Study"
                    class="ml-12 rounded-lg shadow-lg border border-base-300">
                </div>
                <div class="group">
                  <div class="flex items-start gap-4 mb-4">
                    <div
                      class="flex-shrink-0 w-8 h-8 bg-secondary text-secondary-content rounded-full flex items-center justify-center font-bold text-sm">
                      4</div>
                    <div class="flex-1">
                      <h4 class="text-xl font-semibold mb-3 text-black">Open an existing study</h4>
                      <p class="text-black leading-relaxed font-light mb-4">
                      If you already have a study, choose it from the list and click on "connect to study" button.
                      </p>
                    </div>
                  </div>
                  <img src="assets/quickstart/existing-study.png" alt="Cloud Study"
                    class="ml-12 rounded-lg shadow-lg border border-base-300">
                </div>
              </div>
            </div>
            <div>
              <h3 class="text-3xl font-semibold mb-4 text-black">Local Storage</h3>
              <p class="text-black italic">coming soon....</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Workspace Section -->
      <section id="workspace" class="scroll-mt-16 pl-8">
        <h1 class="text-5xl font-bold mb-8 text-black tracking-tight">Workspace</h1>
        <div>
          <p class="mb-8 text-lg text-black leading-relaxed font-light ">
            Your workspace is your personalized environment for managing all aspects of your research projects.
            It provides a centralized hub for accessing your chats, files, editor, terminals, and collaborative
            features.
          </p>
          <img src="assets/quickstart/workspace.png" alt="Workspace Overview"
            class="rounded-lg shadow-lg border border-base-300 mb-4">
          <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-2 mb-8">
            <div
              class="p-6 rounded-xl border border-base-300 hover:border-error transition-all duration-300 group hover:shadow-lg bg-white/5 backdrop-blur-sm">
              <h3 class="text-xl font-semibold mb-3 text-black">Chat Interface</h3>
              <p class="text-black leading-relaxed font-light">Engage in real-time conversations with AI
                assistants to analyze data, generate
                insights, and get instant answers to your research questions.</p>
            </div>
            <div
              class="p-6 rounded-xl border border-base-300 hover:border-error transition-all duration-300 group hover:shadow-lg bg-white/5 backdrop-blur-sm">
              <h3 class="text-xl font-semibold mb-3 text-black">File Management</h3>
              <p class="text-black leading-relaxed font-light">Easily upload, organize, and access your
                research files directly within the
                workspace.</p>
            </div>
            <div
              class="p-6 rounded-xl border border-base-300 hover:border-error transition-all duration-300 group hover:shadow-lg bg-white/5 backdrop-blur-sm">
              <h3 class="text-xl font-semibold mb-3 text-black">Code Editor</h3>
              <p class="text-black leading-relaxed font-light">Write and execute R code with syntax
                highlighting and intelligent code completion
                for statistical analysis.</p>
            </div>
            <div
              class="p-6 rounded-xl border border-base-300 hover:border-error transition-all duration-300 group hover:shadow-lg bg-white/5 backdrop-blur-sm">
              <h3 class="text-xl font-semibold mb-3 text-black">Terminal Access</h3>
              <p class="text-black leading-relaxed font-light">Run analyses and manage your computational
                tasks seamlessly through integrated
                terminal access.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="workflow" class="scroll-mt-16 pl-8">
        <h1 class="text-5xl font-bold mb-8 text-black tracking-tight">Workflows</h1>
        <div>
          <p class="mb-8 text-lg text-black leading-relaxed font-light">
            Workflows are automations of repetitive tasks like converting study protocols into USDM standard or raw data to SDTM standard. Workflows integrate various domain specific tools
            and follows a pre-specified framework to complete the process. You can create custom workflows to enhance productivity and ensure consistency across your projects.
          </p>
          <div class="space-y-8">
            <div class="group">
              <div class="flex items
                -start gap-4 mb-4">
                <div
                  class="flex-shrink-0 w-8 h-8 bg-info text-info-content rounded-full flex items-center justify-center font-bold text-sm">
                  1</div>
                <div class="flex-1">
                  <h3 class="text-2xl font-semibold mb-3 text-black">Creating a Workflow</h3>
                  <p class="text-black leading-relaxed font-light">Click on user profile icon on top right and click on "USDM" from the dropdown menu.</p>
                </div>

              </div>
              <img src="assets/quickstart/select-workflow.png" alt="Create Workflow"
                class="ml-12 rounded-lg shadow-lg border border-base-300">
            </div>
            <div class="group">
              <div class="flex items
                -start gap-4 mb-4">
                <div
                  class="flex-shrink-0 w-8 h-8 bg-info text-info-content rounded-full flex items-center justify-center font-bold text-sm">
                  2</div>
                <div class="flex-1">
                  <h3 class="text-2xl font-semibold mb-3 text-black">Provide workflow details</h3>
                  <h6 class="text-black leading-relaxed font-light">You will be redirected to USDM Automation page.</h6>
                  <p class="text-gray-800 leading-relaxed font-light">Provide your protocol PDF, OSB (Open Study Builder) URL link and Study UID (if already created).</p>
                </div>
              </div>
              <img src="assets/quickstart/select-usdm.png" alt="Workflow Steps"
                class="ml-12 rounded-lg shadow-lg border border-base-300">
            </div>
            <div class="group">
              <div class="flex items
                -start gap-4 mb-4">
                <div
                  class="flex-shrink-0 w-8 h-8 bg-info text-info-content rounded-full flex items-center justify-center font-bold text-sm">
                  3</div>
                <div class="flex-1">
                  <h3 class="text-2xl font-semibold mb-3 text-black">Run the Workflow</h3>
                  <p class="text-black leading-relaxed font-light">After providing all necessary details,
                    click on the "Submit" button to initiate the process.</p>
                </div>
              </div>
              <img src="assets/quickstart/start-workflow.png" alt="Run Workflow"
                class="ml-12 rounded-lg shadow-lg border border-base-300">
            </div>
            <div class="group">
              <div class="flex items
                -start gap-4 mb-4">
                <div
                  class="flex-shrink-0 w-8 h-8 bg-info text-info-content rounded-full flex items-center justify-center font-bold text-sm">
                  4</div>
                <div class="flex-1">
                  <h3 class="text-2xl font-semibold mb-3 text-black">Extract and Mapping</h3>
                  <p class="text-black leading-relaxed font-light">You can extract all states by clicking on "select all" checkbox and then click on "Extract All" button. You can also extract individual states by click on "Extract" button for each state.</p>
                </div>
              </div>
              <img src="assets/quickstart/Extraction-mapping.png" alt="Extract and Mapping"
                class="ml-12 rounded-lg shadow-lg border border-base-300">
            </div>
            <div class="group">
              <div class="flex items
                -start gap-4 mb-4">
                <div
                  class="flex-shrink-0 w-8 h-8 bg-info text-info-content rounded-full flex items-center justify-center font-bold text-sm">
                  5</div>
                <div class="flex-1">
                  <h3 class="text-2xl font-semibold mb-3 text-black">Workflow started</h3>
                  <p class="text-black leading-relaxed font-light">When you click on "Extract All" button, you will see the extraction process in progress. You can monitor the status of each state.</p>
                </div>
              </div>
              <img src="assets/quickstart/workflow-started.png" alt="Workflow Started"
                class="ml-12 rounded-lg shadow-lg border border-base-300">
            </div>
            <div class="group">
              <div class="flex items
                -start gap-4 mb-4">
                <div
                  class="flex-shrink-0 w-8 h-8 bg-info text-info-content rounded-full flex items-center justify-center font-bold text-sm">
                  6</div>
                <div class="flex-1">
                  <h3 class="text-2xl font-semibold mb-3 text-black">Workflow in Progress</h3>
                  <p class="text-black leading-relaxed font-light">If you click on "View/ Validate" button you can see a dialog box with pdf viewer and extraction data and agent thought process.</p>
                </div>
              </div>
              <img src="assets/quickstart/running-workflow.png" alt="Workflow In Progress"
                class="ml-12 mb-4 rounded-lg shadow-lg border border-base-300">
            </div>
            <div class="group">
              <div class="flex items
                -start gap-4 mb-4">
                <div
                  class="flex-shrink-0 w-8 h-8 bg-info text-info-content rounded-full flex items-center justify-center font-bold text-sm">
                  7</div>
                <div class="flex-1">
                  <h3 class="text-2xl font-semibold mb-3 text-black">Workflow Completed</h3>
                  <p class="text-black leading-relaxed font-light">You can see the completed status of all states in the workflow.</p>
                </div>
              </div>
              <img src="assets/quickstart/workflow-completed.png" alt="Workflow Completed"
                class="ml-12 rounded-lg shadow-lg border border-base-300">
            </div>
            <div class="group">
              <div class="flex items
                -start gap-4 mb-4">
                <div
                  class="flex-shrink-0 w-8 h-8 bg-info text-info-content rounded-full flex items-center justify-center font-bold text-sm">
                  8</div>
                <div class="flex-1">
                  <h3 class="text-2xl font-semibold mb-3 text-black">USDM Validation</h3>
                  <p class="text-black leading-relaxed font-light">if you click on next you will be redirected to USDM Validation page. You can see the validation progress. After completing the validation you can download the USDM file.</p>
                </div>
              </div>
              <img src="assets/quickstart/validation.png" alt="Workflow Completed"
                class="ml-12 rounded-lg shadow-lg border border-base-300">
            </div>
            <div class="group">
              <div class="flex items
                -start gap-4 mb-4">
                <div
                  class="flex-shrink-0 w-8 h-8 bg-info text-info-content rounded-full flex items-center justify-center font-bold text-sm">
                  9</div>
                <div class="flex-1">
                  <h3 class="text-2xl font-semibold mb-3 text-black">Download USDM File</h3>
                  <p class="text-black leading-relaxed font-light">After validation is completed you can click on download button to download the USDM file and after downloading you can see the USDM file in our viewer by clicking on "View USDM json on our Viewer" button.</p>
                </div>
              </div>
              <img src="assets/quickstart/validation-completed.png" alt="Access Workflow Results"
                class="ml-12 rounded-lg shadow-lg border border-base-300">
            </div>
            <div class="group">
              <div class="flex items
                -start gap-4 mb-4">
                <div
                  class="flex-shrink-0 w-8 h-8 bg-info text-info-content rounded-full flex items-center justify-center font-bold text-sm">
                  10</div>
                <div class="flex-1">
                  <h3 class="text-2xl font-semibold mb-3 text-black">USDM Viewer</h3>
                  <p class="text-black leading-relaxed font-light">If you click on "View USDM json on our Viewer" button you can see the generated USDM files in a structured format and user-friendly interface.</p>
                </div>
              </div>
              <img src="assets/quickstart/usdm-viewer.png" alt="Review Workflow Outputs"
                class="ml-12 rounded-lg shadow-lg border border-base-300">
            </div>
          </div>
        </div>
      </section>


      <!-- FAQ Section -->
      <section id="faq" class="scroll-mt-16 pl-8">
        <h1 class="text-5xl font-bold mb-8 text-black tracking-tight">FAQ</h1>
        <div class="grid gap-6 md:grid-cols-1 lg:grid-cols-2">
          <div
            class="p-6 rounded-xl border border-base-300 hover:border-[#1594fd] transition-all duration-300 group hover:shadow-lg bg-white/5 backdrop-blur-sm">
            <h3 class="text-xl font-semibold mb-3 text-black">How do I sign in?</h3>
            <p class="text-black leading-relaxed font-light">Use the Google Sign In button on the home page to authenticate quickly and securely.</p>
            <a href="/docs#quickstart" class="text-[#1594fd] underline hover:text-[#1594fd]-focus transition-colors font-medium">Quickstart</a>
          </div>

          <div
            class="p-6 rounded-xl border border-base-300 hover:border-[#1594fd] transition-all duration-300 group hover:shadow-lg bg-white/5 backdrop-blur-sm">
            <h3 class="text-xl font-semibold mb-3 text-black">How do I create a new study?</h3>
            <p class="text-black leading-relaxed font-light">Click "+ Study" on the home page and follow the guided flow. Choose Cloud Storage to create a cloud study container (local storage coming soon).</p>
            <a href="/docs#studies" class="text-[#1594fd] underline hover:text-[#1594fd]-focus transition-colors font-medium">Studies</a>
          </div>

          <div
            class="p-6 rounded-xl border border-base-300 hover:border-[#1594fd] transition-all duration-300 group hover:shadow-lg bg-white/5 backdrop-blur-sm">
            <h3 class="text-xl font-semibold mb-3 text-black">What can I do in the workspace?</h3>
            <p class="text-black leading-relaxed font-light">The workspace provides chat for Q&A, file management, a code editor with R support, and terminal access so you can run analyses and collaborate.</p>
            <a href="/docs#workspace" class="text-[#1594fd] underline hover:text-[#1594fd]-focus transition-colors font-medium">Workspace</a>
          </div>

          <div
            class="p-6 rounded-xl border border-base-300 hover:border-[#1594fd] transition-all duration-300 group hover:shadow-lg bg-white/5 backdrop-blur-sm">
            <h3 class="text-xl font-semibold mb-3 text-black">How do workflows work?</h3>
            <p class="text-black leading-relaxed font-light">Create or select a workflow from the Workflows page, provide required inputs (protocol PDF, OSB URL, options) and click Confirm to start the automation.</p>
            <a href="/docs#workflow" class="text-[#1594fd] underline hover:text-[#1594fd]-focus transition-colors font-medium">Workflows</a>
          </div>

          <div
            class="p-6 rounded-xl border border-base-300 hover:border-[#1594fd] transition-all duration-300 group hover:shadow-lg bg-white/5 backdrop-blur-sm">
            <h3 class="text-xl font-semibold mb-3 text-black">How do I monitor and access results?</h3>
            <p class="text-black leading-relaxed font-light">Monitor workflow progress in the workspace; click the OSB icon for detailed progress. When finished, open the Editor or USDM Json Viewer to review outputs and generated files.</p>
            <a href="/docs#workflow" class="text-[#1594fd] underline hover:text-[#1594fd]-focus transition-colors font-medium">View Results</a>
          </div>

          <div
            class="p-6 rounded-xl border border-base-300 hover:border-[#1594fd] transition-all duration-300 group hover:shadow-lg bg-white/5 backdrop-blur-sm">
            <h3 class="text-xl font-semibold mb-3 text-black">What file formats are supported?</h3>
            <p class="text-black leading-relaxed font-light">Studies support common research formats — CSV, JSON, Excel (XLSX), R scripts and PDFs for protocols and other media for upload, analysis, and export.</p>
            <a href="/docs#studies" class="text-[#1594fd] underline hover:text-[#1594fd]-focus transition-colors font-medium">File Formats</a>
          </div>
        </div>
      </section>

        <a href="/docs#quickstart" title="Back to top" aria-label="Back to top"
           class="fixed right-6 bottom-6 z-50 inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#1594fd] text-white shadow-lg hover:-translate-y-1 transition-transform duration-200 focus:outline-none focus:ring-2 focus:ring-primary">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7"/>
          </svg>
        </a>
    </div>
  </main>
  <aside class="w-64 p-4 overflow-y-auto h-full">
  </aside>
</div>
